const ENDPOINT = 'POSTfingerprint';
function postFingerPrint(gateway, params = {}) {
    return gateway.get(postFingerPrint.endpoint, params);
}
postFingerPrint.endpoint = ENDPOINT;

export { postFingerPrint as default };
//# sourceMappingURL=postFingerPrint.js.map
